var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 98,
    width: 141,
    height: 44,
    rx: 17,
    fill: "#02475E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 84,
    width: 109,
    height: 27,
    rx: 5,
    fill: "#02475E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 64,
    width: 80,
    height: 27,
    rx: 5,
    fill: "#02475E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 51,
    width: 48,
    height: 27,
    rx: 5,
    fill: "#02475E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.997 76.7517C148.9 65.0501 140.105 55.3433 128.962 49.1196C117.818 42.896 104.941 40.4989 92.3047 42.296C79.6682 44.0931 67.9699 49.9852 59.0034 59.0688C50.0368 68.1525 44.297 79.9262 42.664 92.585C34.7189 94.4877 27.7492 99.242 23.0785 105.945C18.4078 112.648 16.3614 120.833 17.3279 128.945C18.2944 137.058 22.2065 144.533 28.3213 149.951C34.436 155.369 42.3276 158.352 50.4974 158.335H142.164C152.159 158.307 161.81 154.688 169.359 148.137C176.907 141.587 181.85 132.541 183.284 122.649C184.719 112.758 182.551 102.681 177.174 94.2555C171.798 85.83 163.572 79.6177 153.997 76.7517V76.7517ZM142.164 141.668H50.4974C46.0771 141.668 41.8379 139.912 38.7123 136.787C35.5867 133.661 33.8307 129.422 33.8307 125.002C33.8307 120.581 35.5867 116.342 38.7123 113.217C41.8379 110.091 46.0771 108.335 50.4974 108.335C52.7075 108.335 54.8271 107.457 56.3899 105.894C57.9527 104.331 58.8307 102.212 58.8307 100.002C58.852 90.1457 62.3664 80.6163 68.7496 73.1065C75.1328 65.5968 83.9715 60.5929 93.6953 58.9839C103.419 57.375 113.398 59.265 121.86 64.3184C130.322 69.3718 136.719 77.2612 139.914 86.585C140.403 88.0015 141.265 89.2599 142.409 90.2278C143.552 91.1958 144.936 91.8373 146.414 92.085C152.522 93.2121 157.992 96.5727 161.758 101.512C165.524 106.452 167.317 112.616 166.786 118.805C166.256 124.994 163.441 130.763 158.889 134.99C154.337 139.216 148.375 141.597 142.164 141.668V141.668Z",
    fill: "#F78670"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudInProgress);
export default __webpack_public_path__ + "static/media/cloudInProgress.2f1d52b4d760d91ebcb9eff913258f85.svg";
export { ForwardRef as ReactComponent };